import {useRef} from "react";

export default () => {
    const cu = useRef<number>(1)

    return {
        current:cu.current,
        refresh:() => {
            ++cu.current
        }
    }
}
